@if (dateRangeForm) {
  @if (fieldStyle) {
    <div class="tidy-daterange-field" (click)="!disabled && openDatePicker()">
      @if (label) {
        <tidy-text
          [fieldLabel]="label"
          class="field-label" />
      }
      <div
        class="input-container"
        [class.invalid-field]="!dateRangeForm.valid && submitted"
        [class.disabled]="disabled">
        @if (icon) {
          <tidy-image [src]="icon" class="input-icon" />
        }
        <mat-date-range-input [rangePicker]="picker" #dateRangeInput [disabled]="disabled" [dateFilter]="dateFilter">
          <input #startDateInput matStartDate [formControl]="dateRangeForm.controls.start" [placeholder]="placeholder | translate" readonly>
          <input matEndDate [formControl]="dateRangeForm.controls.end" (dateChange)="emitOptionChange()" readonly>
        </mat-date-range-input>
        <div class="daterange-arrow">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M5 4.5L8 2L11 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 11.5L8 14L11 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <mat-date-range-picker #picker />
      </div>
    </div>
  }
  @if (!fieldStyle && !showRangeOptions && rangeOption === 'custom') {
    <mat-form-field (click)="customOnly ? openDatePicker() : openOptionsPicker()" [appearance]="appearance" [class.header]="header" [disabled]="disabled">
      @if (label) {
        <mat-label class="vertical-align-center">
          <tidy-text [body]="label" />
        </mat-label>
      }
      <mat-date-range-input [rangePicker]="picker" #dateRangeInput [disabled]="disabled" [dateFilter]="dateFilter">
        <input #startDateInput matStartDate [formControl]="dateRangeForm.controls.start">
        <input matEndDate [formControl]="dateRangeForm.controls.end" (dateChange)="emitOptionChange()">
      </mat-date-range-input>
      <tidy-image
        [src]="'assets/svg/caret-down.svg'"
        class="caret-icon" />
      <mat-date-range-picker #picker />
    </mat-form-field>
  }
  @if (!fieldStyle && !showRangeOptions && rangeOption !== 'custom') {
    <mat-form-field (click)="openOptionsPicker()" [appearance]="appearance" [class.header]="header" [disabled]="disabled">
      @if (label) {
        <mat-label class="vertical-align-center">
          <tidy-text [body]="label" />
        </mat-label>
      }
      <mat-select [formControl]="dateRangeForm.controls.customStringSelect" [disabled]="disabled">
        @for (option of selectOptions; track option) {
          <mat-option [value]="option.value">{{option.viewValue | translate}}</mat-option>
        }
      </mat-select>
      <mat-date-range-picker #picker />
    </mat-form-field>
  }
  @if (!fieldStyle && showRangeOptions) {
    <mat-form-field [appearance]="appearance" [class.header]="header" [disabled]="disabled">
      @if (label) {
        <mat-label class="vertical-align-center">
          <tidy-text [body]="label" />
        </mat-label>
      }
      <mat-select #optionsPicker (selectionChange)="selectOption($event.value)" [formControl]="dateRangeForm.controls.customStringSelect" [disabled]="disabled">
        @for (option of selectOptions; track option) {
          <mat-option [value]="option.value">{{option.viewValue | translate}}</mat-option>
        }
      </mat-select>
      <mat-date-range-picker #picker />
    </mat-form-field>
  }
  @if (!dateRangeForm.valid && submitted) {
    <tidy-error-message [text]="errorMessage" />
  }
}
